import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ModalController } from '@ionic/angular'
import { TranslateService } from '@ngx-translate/core'

import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service'
import { UtilitiesService } from '../../../../shared/services/utilities/utilities.service'
import { YoutubeService } from '../../../../shared/services/youtube/youtube.service'
import { Noticias } from '../../models/Noticias'
import { ModalDetailComponent } from '../modal-detail/modal-detail.component'


@Component({
  selector: 'app-noticias-cards',
  templateUrl: './noticias-cards.component.html',
  styleUrls: ['./noticias-cards.component.scss'],
})
export class NoticiasCardsComponent implements OnInit, OnDestroy {

  @Input() item: Noticias = {}

  public openModal: any = null
  public isIos = false

  constructor(
    private modalController: ModalController,
    private youtubeService: YoutubeService,
    private translate: TranslateService,
    private sharedAnalyticsS: SharedAnalyticsService,
    private utilitiesS: UtilitiesService
  ) { }

  ngOnInit(): void {
    this.isIos = this.youtubeService.isIOS()
  }

  ngOnDestroy(): void {
    if (this.openModal !== null) {
      this.openModal.dismiss()
    }
  }

  public get videoId(): string {
    return this.youtubeService.extractVideoId(this.item.Recurso || '')
  }

  public get thumbnailUrl(): string {
    return this.youtubeService.getThumbnailUrl(this.videoId)
  }

  public onImageError = (event: Event): void => {
    const img = event.target as HTMLIonImgElement
    img.src = this.translate.instant('Icons.logo-pepsi')
    img.className = 'error-image'
  }

  public onThumbnailError = (event: Event): void => {
    const img = event.target as HTMLIonImgElement
    img.src = this.translate.instant('Icons.img-placeholder-youtube')
  }

  public async openYouTubeApp(event: Event): Promise<void> {
    event.stopPropagation()
    await this.youtubeService.openVideo(this.videoId)
  }

  public async openModalDetail(): Promise<void> {
    this.sendAnalyticInteractionArticle();
    this.openModal = await this.modalController.create({
      component: ModalDetailComponent,
      mode: 'md',
      backdropDismiss: true,
      cssClass: 'ion-modal-news',
      componentProps: { noticia: this.item }
    })

    await this.openModal.present()
    await this.openModal.onDidDismiss()
  }

  private sendAnalyticInteractionArticle(): void {
    const formattedDate = this.utilitiesS.formatearFechaTermino(this.item.FechaVigenciaInicial || '')

    // TODO: categoria_del_articulo is currently hardcoded to "Todos" but may change in the future
    const categoria = 'Todos'

    this.sharedAnalyticsS.sendInteractionArticle({
      titulo_del_articulo: this.item.Titulo || '',
      fecha_de_publicacion: formattedDate,
      categoria_del_articulo: categoria
    })
  }
}
